import { useQuery } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { makeDashboardApi } from '../DashboardApi';
import { IBookingsByDestinationRequest, IDestinationBreakdownResponse } from '../types';

export const useBookingsByDestination = (request: IBookingsByDestinationRequest) => {
  const bookingsByDestination = useQuery<AxiosResponse<IDestinationBreakdownResponse>, AxiosError>({
    queryKey: ['bookings-by-destination', request],
    queryFn: () => {
      return makeDashboardApi().getBookingsByDestination(request);
    },
    retry: false,
  });

  return {
    bookingsByDestinationData: bookingsByDestination.data?.data,
    isLoadingBookingsByDestinationData: bookingsByDestination.isLoading,
    isErrorBookingsByDestinationData: bookingsByDestination.isError,
  };
};

